(function () {
  var artistInfoLastFocus = null;
  var charityInfoLastFocus = null;
  var charityInfoEventsReady = false;

  function $(id) {
    return document.getElementById(id);
  }

  function getState() {
    var api = window.MakePortraitArtistInfoApi || {};
    return api.state || {};
  }

  function setArtistInfoPanel(artistId, styleId) {
    var panels = document.querySelectorAll('.make-portrait__artist-info-panel');
    var activePanel = null;

    panels.forEach(function (panel) {
      var isActive = artistId && panel.dataset.artistId === artistId;
      panel.hidden = !isActive;
      if (isActive) activePanel = panel;
    });

    if (!activePanel && panels.length) {
      activePanel = panels[0];
      activePanel.hidden = false;
    }
    if (!activePanel) return null;

    return activePanel;
  }

  function closeArtistInfoPopup() {
    var dialog = $('mp-artist-info-dialog');
    var backdrop = $('mp-artist-info-backdrop');

    if (dialog) dialog.hidden = true;
    if (backdrop) backdrop.hidden = true;
    document.documentElement.classList.remove('make-portrait-artist-info-open');
    if (document.body) document.body.classList.remove('make-portrait-artist-info-open');

    if (artistInfoLastFocus && typeof artistInfoLastFocus.focus === 'function') {
      try {
        artistInfoLastFocus.focus({ preventScroll: true });
      } catch (e) {
        artistInfoLastFocus.focus();
      }
    }
    artistInfoLastFocus = null;
  }

  function setCharityInfoExpanded(expanded) {
    document.querySelectorAll('[data-mp-charity-popup-open]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function closeCharityInfoPopup() {
    var dialog = $('mp-charity-info-dialog');
    var backdrop = $('mp-charity-info-backdrop');

    if (dialog) dialog.hidden = true;
    if (backdrop) backdrop.hidden = true;
    document.documentElement.classList.remove('make-portrait-artist-info-open');
    if (document.body) document.body.classList.remove('make-portrait-artist-info-open');
    setCharityInfoExpanded(false);

    if (charityInfoLastFocus && typeof charityInfoLastFocus.focus === 'function') {
      try {
        charityInfoLastFocus.focus({ preventScroll: true });
      } catch (e) {
        charityInfoLastFocus.focus();
      }
    }
    charityInfoLastFocus = null;
  }

  function openCharityInfoPopup(trigger) {
    var dialog = $('mp-charity-info-dialog');
    var backdrop = $('mp-charity-info-backdrop');

    if (!dialog) return;

    charityInfoLastFocus = trigger || document.activeElement;
    if (backdrop) backdrop.hidden = false;
    dialog.hidden = false;
    dialog.scrollTop = 0;
    document.documentElement.classList.add('make-portrait-artist-info-open');
    if (document.body) document.body.classList.add('make-portrait-artist-info-open');
    setCharityInfoExpanded(true);

    window.requestAnimationFrame(function () {
      var closeButton = $('mp-charity-info-close');
      var focusTarget = closeButton || dialog;
      if (!focusTarget || typeof focusTarget.focus !== 'function') return;
      try {
        focusTarget.focus({ preventScroll: true });
      } catch (e) {
        focusTarget.focus();
      }
    });
  }

  function openArtistInfoPopup() {
    var state = getState();
    var dialog = $('mp-artist-info-dialog');
    var backdrop = $('mp-artist-info-backdrop');

    if (!dialog) return;

    var activePanel = setArtistInfoPanel(state.style && state.style.artistId, state.styleId);
    if (!activePanel) return;

    artistInfoLastFocus = document.activeElement;
    if (backdrop) backdrop.hidden = false;
    dialog.hidden = false;
    dialog.scrollTop = 0;
    document.documentElement.classList.add('make-portrait-artist-info-open');
    if (document.body) document.body.classList.add('make-portrait-artist-info-open');

    window.requestAnimationFrame(function () {
      var closeButton = $('mp-artist-info-close');
      var focusTarget = closeButton || dialog;
      if (!focusTarget || typeof focusTarget.focus !== 'function') return;
      try {
        focusTarget.focus({ preventScroll: true });
      } catch (e) {
        focusTarget.focus();
      }
    });
  }

  function getScrollOffset() {
    var headerHeight = 0;
    var bodyStyles = window.getComputedStyle(document.body);
    var cssHeaderHeight = parseFloat(bodyStyles.getPropertyValue('--header-height')) || 0;
    var header = document.querySelector('#header-component, .header-section');
    if (header) {
      var headerRect = header.getBoundingClientRect();
      headerHeight = Math.max(headerHeight, headerRect.height || 0);
    }
    return Math.round(Math.max(headerHeight, cssHeaderHeight) + 16);
  }

  function showArtistTabPanel() {
    var artistPanel = $('tab-artist');
    var artistTabButton = document.querySelector('.tab-nav__btn[data-tab="artist"]');
    if (artistTabButton && typeof artistTabButton.click === 'function') {
      artistTabButton.click();
      return;
    }

    if (artistPanel) artistPanel.hidden = false;
  }

  function scrollToArtistPanel(event) {
    if (event) event.preventDefault();
    showArtistTabPanel();

    var artistPanel = $('tab-artist');
    if (!artistPanel) return;

    window.requestAnimationFrame(function () {
      var targetTop = artistPanel.getBoundingClientRect().top + window.pageYOffset - getScrollOffset();
      targetTop = Math.max(0, Math.round(targetTop));
      var lenis = window.BarkFrameLenis || window.lenis || null;
      if (lenis && typeof lenis.scrollTo === 'function') {
        try {
          lenis.scrollTo(targetTop, { duration: 0.65, force: true });
          return;
        } catch (e) {}
      }
      window.scrollTo({ top: targetTop, left: 0, behavior: 'smooth' });
    });
  }

  function initArtistInfoPopup() {
    var dialog = $('mp-artist-info-dialog');
    var closeButton = $('mp-artist-info-close');
    var backdrop = $('mp-artist-info-backdrop');
    var artistBadge = $('mp-artist-badge');

    if (!dialog || dialog.dataset.artistInfoReady === 'true') return;
    dialog.dataset.artistInfoReady = 'true';

    ['mp-artist-info-backdrop', 'mp-artist-info-dialog'].forEach(function (id) {
      var el = $(id);
      if (el) document.body.appendChild(el);
    });

    if (artistBadge) {
      artistBadge.addEventListener('click', scrollToArtistPanel);
    }
    document.querySelectorAll('.tab-artist-panel[role="button"]').forEach(function (panel) {
      panel.addEventListener('click', openArtistInfoPopup);
      panel.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openArtistInfoPopup();
      });
    });

    if (closeButton) closeButton.addEventListener('click', closeArtistInfoPopup);
    if (backdrop) backdrop.addEventListener('click', closeArtistInfoPopup);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !dialog.hidden) closeArtistInfoPopup();
    });

  }

  function initCharityInfoPopup() {
    var dialog = $('mp-charity-info-dialog');
    var closeButton = $('mp-charity-info-close');
    var backdrop = $('mp-charity-info-backdrop');

    if (!dialog || dialog.dataset.charityInfoReady === 'true') return;
    dialog.dataset.charityInfoReady = 'true';

    ['mp-charity-info-backdrop', 'mp-charity-info-dialog'].forEach(function (id) {
      var el = $(id);
      if (el) document.body.appendChild(el);
    });

    if (!charityInfoEventsReady) {
      document.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-mp-charity-popup-open]');
        if (!trigger) return;
        event.preventDefault();
        openCharityInfoPopup(trigger);
      });

      document.addEventListener('keydown', function (event) {
        var activeDialog = $('mp-charity-info-dialog');
        if (event.key === 'Escape' && activeDialog && !activeDialog.hidden) closeCharityInfoPopup();
      });

      charityInfoEventsReady = true;
    }

    if (closeButton) closeButton.addEventListener('click', closeCharityInfoPopup);
    if (backdrop) backdrop.addEventListener('click', closeCharityInfoPopup);
  }

  window.MakePortraitArtistInfo = {
    open: openArtistInfoPopup,
    close: closeArtistInfoPopup
  };
  window.MakePortraitCharityInfo = {
    open: openCharityInfoPopup,
    close: closeCharityInfoPopup
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArtistInfoPopup);
    document.addEventListener('DOMContentLoaded', initCharityInfoPopup);
  } else {
    initArtistInfoPopup();
    initCharityInfoPopup();
  }
})();
